import React, { useState } from 'react'
import bdLogo from '../../../public/Bitmap.png'

export default function AdminLogin({ setToken }) {
  const [username, setUserName] = useState()
  const [password, setPassword] = useState()

  const handleSubmit = async (e) => {
    e.preventDefault()
    const token = {
      username,
      password,
    }

    if (
      username === `${process.env.REACT_APP_ADMIN_USER}` &&
      password === `${process.env.REACT_APP_ADMIN_PW}`
    ) {
      setToken(token)
    } else {
      console.log('invalid credentials')
      alert('Invalid credentials')
    }
  }

  return (
    <div className='admin-login-wrapper'>
      <img src={bdLogo} alt='bdLogo' />
      <h1>Admin Log In</h1>
      <form className='admin-form-wrapper' onSubmit={handleSubmit}>
        <label className='admin-login-username'>
          <div>Username</div>
          <input type='text' onChange={(e) => setUserName(e.target.value)} />
        </label>
        <label className='admin-login-password'>
          <div>Password</div>
          <input
            type='password'
            onChange={(e) => setPassword(e.target.value)}
          />
        </label>
        <div className='admin-login-submit'>
          <button type='submit'>Submit</button>
        </div>
      </form>
    </div>
  )
}
